import React from "react";

export default function NotFound() {
  return (
    <div>
      <h3>Sorry, page not found!</h3>
    </div>
  );
}
